import React, { PropsWithChildren, ReactNode } from "react";
import cs from "classnames";

export const DefaultTemplate = ({
  children,
  className,
}: PropsWithChildren<{ children: ReactNode; className?: string }>) => {
  return <div className={cs("DefaultTemplate p-4", className)}>{children}</div>;
};
